import { constants } from "../constants";

export const setLang = (lang) => {
  return {
    type: constants.CHANGE_LANG,
    payload: lang,
  };
};
